import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { SubmitButton } from '../../../../../atoms/SubmitButton';
import { useScrollToTop } from '../../../../../hooks/useScrollToTop';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import PurchaseErrorMessage from '../PurchaseErrorMessage';

import css from './CompletionFailed.module.scss';

interface ElementProps {
  schemeType: IPurchases.SchemeType;
  settings: IPurchases.SettingCompletion;
  backTo?: {
    label: string;
    modifyPage: () => void;
  };
}

type Props = ElementProps;

const CompletionFailed: FC<Props> = (props: Props) => {
  useScrollToTop();
  const { schemeType, settings, backTo } = props;
  const intl = useIntl();
  const labelType =
    schemeType === IPurchases.SchemeType.Subscription
      ? 'subscription'
      : 'ticketBook';
  return (
    <div className={css.CompletionFailed}>
      {settings.entireErrors && (
        <>
          {settings.entireErrors.map((errorType) => (
            <PurchaseErrorMessage
              key={errorType}
              labelType={labelType}
              errorType={errorType}
              className={css.CompletionFailed__ErrorMessage}
            />
          ))}
        </>
      )}
      {backTo && (
        <SubmitButton
          onClick={backTo.modifyPage}
          value={intl.formatMessage({
            id: backTo.label,
          })}
        >
          {intl.formatMessage({
            id: backTo.label,
          })}
        </SubmitButton>
      )}
    </div>
  );
};

export default CompletionFailed;
